<template>
  <div class="home-page">
    <div class="container">
      <div class="welcome-section">
        <h1>Bienvenido a Vida Más Salud</h1>
        <p>Sistema de gestión médica integral</p>
        <div class="qr-info">
          <h3>¿Cómo usar el QR?</h3>
          <p>Escanea el código QR de tu cita médica para ver todos los detalles de tu consulta.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  color: white;
}

.welcome-section h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.welcome-section p {
  font-size: 1.2rem;
  margin-bottom: 3rem;
  opacity: 0.9;
}

.qr-info {
  background: rgba(255, 255, 255, 0.15);
  padding: 2rem;
  border-radius: 16px;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(30, 64, 175, 0.2);
}

.qr-info h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.qr-info p {
  font-size: 1rem;
  line-height: 1.6;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .welcome-section h1 {
    font-size: 2rem;
  }
  
  .welcome-section p {
    font-size: 1rem;
  }
}
</style> 